export function paramsFromQuery(mainParams, queryParams){
  let search_query = queryParams.search_query
  let page = queryParams.pageNo
  let as = queryParams.as
  let is_advanced_search = queryParams.is_advanced_search
  let sortKey = queryParams.sortKey;
  let sortDir = queryParams.sortDir;
  if(search_query){
    // mainParams['as'] = true
    mainParams['search_query'] = search_query;
  }
  if(page){
    mainParams['page'] = page
  }
  if(as){
    mainParams['as'] = true
  }
  if(is_advanced_search){
    mainParams['is_advanced_search'] = true
  }
  if(sortKey){
    mainParams['key'] = decodeSortKey(sortKey)
    mainParams['sort'] = sortDir || 'asc'
  }
}
export function decodeEnquiryParams(EnquiryParams){
  let senddata = {}
  let builders_enquiries_attributes = {}
  let building_attributes = []
  senddata['id'] = EnquiryParams.enquiry_id
  senddata['vcm_done'] = EnquiryParams.vcm_done
  senddata['vcm_done_date'] = EnquiryParams.vcm_done_date
  senddata['visited'] = EnquiryParams.visited
  senddata['visit_date'] = EnquiryParams.visit_date
  senddata['obm_done'] = EnquiryParams.obm_done
  senddata['is_nri'] = EnquiryParams.is_nri
  senddata['obm_done_date'] = EnquiryParams.obm_done_date
  senddata['dead_reason'] = EnquiryParams.dead_reason
  senddata['dead_reason_comment'] = EnquiryParams.dead_reason_comment
  builders_enquiries_attributes['next_call_date'] = EnquiryParams.next_call_date
  builders_enquiries_attributes['status_id'] = EnquiryParams.status_id
  builders_enquiries_attributes['executive_comments'] = EnquiryParams.executive_comments
  builders_enquiries_attributes['id'] = EnquiryParams.id
  building_attributes.push(builders_enquiries_attributes);
  senddata['builders_enquiries_attributes'] = building_attributes
  return senddata;
}
export function decodeMeetingParams(Meeting, Campaigns){
  let senddata = new FormData();
  let campaigns_attributes = []
  senddata.append('users_meeting[broker_id]',Meeting.broker_id);
  senddata.append('users_meeting[user_id]',(Meeting.user_id && Meeting.user_id.value ? Meeting.user_id.value : ''));
  senddata.append('users_meeting[start_date_time]',Meeting.start_date_time);
  senddata.append('users_meeting[end_date_time]',Meeting.end_date_time);
  senddata.append('users_meeting[rating_to_broker]',Meeting.rating_to_broker);
  senddata.append('users_meeting[comment]',Meeting.comment);
  senddata.append('users_meeting[meeting_type]',Meeting.meeting_type ? Meeting.meeting_type : '');
  senddata.append('users_meeting[app_engagement]',Meeting.app_engagement);
  senddata.append('users_meeting[location]',Meeting.location);
  senddata.append('users_meeting[meeting_executive_lat]',Meeting.meeting_executive_lat);
  senddata.append('users_meeting[meeting_executive_long]',Meeting.meeting_executive_long);
  if (Meeting.executive_image) {
    senddata.append('users_meeting[executive_image]',Meeting.executive_image,Meeting.executive_image.name);
  }
  if (Meeting.recording !== null || "") {
    senddata.append("users_meeting[recorded_audio]",Meeting.recording);
    senddata.append("users_meeting[recorded_audio_duration]",Meeting.recorded_audio_duration);
  }
  if (Meeting.app_engagement) {
    senddata.append('users_meeting[listing_count]',Meeting.listing_count);
    senddata.append('users_meeting[lead_count]',Meeting.lead_count);
    senddata.append('users_meeting[requirement_count]',Meeting.requirement_count);
  } else {
    senddata.append('users_meeting[no_app_engagement_comments]',Meeting.no_app_engagement_comments);
  }
  Campaigns.forEach((Campaign,index) => {
    senddata.append(`users_meeting[campaigns_attributes][${index}][start_date]`,Campaign.start_date);
    senddata.append(`users_meeting[campaigns_attributes][${index}][end_date]`,Campaign.end_date);
    senddata.append(`users_meeting[campaigns_attributes][${index}][campaign_type]`,Campaign.campaign_type);
    senddata.append(`users_meeting[campaigns_attributes][${index}][title]`,Campaign.title);
    senddata.append(`users_meeting[campaigns_attributes][${index}][achieved]`,Campaign.achieved);
    senddata.append(`users_meeting[campaigns_attributes][${index}][enquiries_count]`,Campaign.enquiries_count);
    senddata.append(`users_meeting[campaigns_attributes][${index}][building_id]`,Campaign.building_id.value);
    senddata.append(`users_meeting[campaigns_attributes][${index}][compaign_data]`,Campaign.compaign_data);
    senddata.append(`users_meeting[campaigns_attributes][${index}][executive_comments]`,Campaign.executive_comments);
    senddata.append(`users_meeting[campaigns_attributes][${index}][executed]`,Campaign.executed);
    senddata.append(`users_meeting[campaigns_attributes][${index}][_destroy]`,Campaign._destroy);
    senddata.append(`users_meeting[campaigns_attributes][${index}][created_by]`,localStorage.getItem('radiate-user-id'));
  });
  return senddata;
}

export function decodeEditDailyMeeting(editMeeting) {
  console.log(editMeeting,"edit meeting from utitliey")
  let senddata = new FormData();
  senddata.append("actual_enq_sourced", editMeeting.actual_enq_sourced);
  senddata.append("begning_of_created_at", editMeeting.begning_of_created_at);
  senddata.append("can_edit_daily_stand_up", editMeeting.can_edit_daily_stand_up);
  senddata.append("created_at", editMeeting.created_at);
  senddata.append("end_of_created_at", editMeeting.end_of_created_at);
  senddata.append("field_executive", editMeeting.field_executive);
  senddata.append("id", editMeeting.id);
  senddata.append("meeting_executive_id", editMeeting.meeting_executive_id)
  senddata.append("todays_meeting_done", editMeeting.todays_meeting_done);
  senddata.append("todays_meeting_target",editMeeting.todays_meeting_target);
  senddata.append("enquiry_sourcing_target", editMeeting.enquiry_sourcing_target);
  senddata.append("comment", editMeeting.comment);
  senddata.append("selfie_photo_url", editMeeting.selfie_photo_url);
  senddata.append("location", editMeeting.location);
  senddata.append("signing_off_edit_daily_stand_up", editMeeting.signing_off_edit_daily_stand_up);
  senddata.append("signing_off_location", editMeeting.signing_off_location);
  senddata.append("signing_off_meeting_lat", editMeeting.signing_off_meeting_lat);
  senddata.append("signing_off_meeting_long", editMeeting.signing_off_meeting_long);
  if(editMeeting.signing_off_selfie_photo) {
    senddata.append("signing_off_selfie_photo", editMeeting.signing_off_selfie_photo);
  }
  senddata.append("signing_off_selfie_photo_url", editMeeting.signing_off_selfie_photo_url);
  senddata.append('stand_up_type',editMeeting.stand_up_type);
  if(editMeeting.stand_up_type=='Outdoor Duty')
  {
  senddata.append('od_start_time',editMeeting.od_start_time);
  senddata.append('od_end_time',editMeeting.od_end_time);
  }
  return senddata;
}
export function decodeDailyMeetingParams(Meeting){
  let senddata = new FormData();
  senddata.append('enquiry_sourcing_target',Meeting.enquiry_sourcing_target);
  senddata.append('todays_meeting_target',Meeting.todays_meeting_target);
  senddata.append('location',Meeting.location);
  senddata.append('comment',Meeting.comment);
  senddata.append('meeting_lat',Meeting.meeting_lat);
  senddata.append('meeting_long',Meeting.meeting_long);
  senddata.append('selfie_photo',Meeting.selfie_photo);
  senddata.append('stand_up_type',Meeting.standup_type);
  if(Meeting.standup_type=='Outdoor Duty')
  {
  senddata.append('od_start_time',Meeting.start_date);
  senddata.append('od_end_time',Meeting.end_date);
  }
  return senddata;
}

export function decodeEditMeetingParams(Meeting, Campaigns){
  let isFromMyMeeting = sessionStorage.getItem("isFromMyMeetings");
  let senddata = {}
  if(!isFromMyMeeting) {
    let campaigns_attributes = []
    senddata['id'] = Meeting.id
    senddata['broker_id'] = Meeting.broker_id
    senddata['user_id'] = Meeting.user_id && Meeting.user_id.value ? Meeting.user_id.value : '';
    senddata['start_date_time'] = Meeting.start_date
    senddata['end_date_time'] = Meeting.end_date
    senddata['rating_to_broker'] = Meeting.rating_to_broker
    senddata['comment'] = Meeting.comment
    if(Meeting?.minutes_of_meeting) {
      senddata['minutes_of_meeting'] = Meeting?.minutes_of_meeting
    }
    senddata['meeting_type'] = Meeting.meeting_type ? Meeting.meeting_type : '';
    senddata['app_engagement'] = Meeting.app_engagement
    senddata['location'] = Meeting.location
    if (Meeting.app_engagement) {
      senddata['listing_count'] = Meeting.listing_count
      senddata['lead_count'] = Meeting.lead_count
      senddata['requirement_count'] = Meeting.requirement_count
    } else {
      senddata['no_app_engagement_comments'] = Meeting.no_app_engagement_comments
    }
    if(Campaigns) {
      Campaigns.forEach(Campaign => {
        let campaignattribute = {}
        campaignattribute['id'] = Campaign.id
        campaignattribute['start_date'] = Campaign.start_date
        campaignattribute['end_date'] = Campaign.end_date
        campaignattribute['campaign_type'] = Campaign.campaign_type
        campaignattribute['title'] = Campaign.title
        campaignattribute['achieved'] = Campaign.achieved
        campaignattribute['enquiries_count'] = Campaign.enquiries_count
        campaignattribute['building_id'] = Campaign.building_id.value
        campaignattribute['compaign_data'] = Campaign.compaign_data
        campaignattribute['executive_comments'] = Campaign.executive_comments
        campaignattribute['executed'] = Campaign.executed
        campaignattribute['_destroy'] = Campaign._destroy
        campaignattribute['created_by'] = localStorage.getItem('radiate-user-id')
        campaigns_attributes.push(campaignattribute);
      });
      senddata['campaigns_attributes'] = campaigns_attributes
    }
  }else if(isFromMyMeeting) {
    senddata['minutes_of_meeting'] = Meeting?.minutes_of_meeting;
    senddata['start_date'] = Meeting?.start_date;
    senddata['end_date'] = Meeting?.end_date;
    senddata['meeting_type'] = Meeting?.meeting_type
  }
  return senddata;
}

export function prepareEnquiriesSearchParams(advSParams){
  let toSend = {}
    if (advSParams.save_search_id) {
      toSend['save_search_id'] = advSParams.save_search_id
    }
    toSend['name'] = advSParams.name
    toSend['phone'] = advSParams.phone
    toSend['email'] = advSParams.email
    toSend['comment']= advSParams.comment
    toSend['enquiry_no'] = advSParams.enquiry_no
    toSend['next_call_date_from'] = advSParams.next_call_date_from
    toSend['next_call_date_upto'] = advSParams.next_call_date_upto
    toSend['visit_date_from'] = advSParams.visit_date_from
    toSend['visit_date_upto'] = advSParams.visit_date_upto
    toSend['created_at_from'] = advSParams.created_at_from
    toSend['created_at_upto'] = advSParams.created_at_upto
    toSend["enquiry_source_id"] = advSParams.enquiry_source_id
    toSend["visited"] = advSParams.visited
    toSend["is_nri"] = advSParams.is_nri
    toSend["remove_recycled_enq"] = advSParams.remove_recycled_enq
    if (advSParams.building_id) {
      toSend["building_ids"] = advSParams.building_id.map(i => i.value).filter(i => i!== null)
    }
    if (advSParams.dead_reason_seq_ids) {
    toSend["dead_reason_seq_ids"] = advSParams.dead_reason_seq_ids.filter(i => i!== null)
  } if (advSParams.enquiry_statuses) {
    toSend["enquiry_statuses"] = advSParams.enquiry_statuses.filter(i => i!== null)
  } if (advSParams.broker_ids) {
    toSend["broker_ids"] = advSParams.broker_ids.filter(i => i!== null)
  } if (advSParams.assigned_to) {
    toSend["assigned_to"] = advSParams.assigned_to.filter(i => i!== null)
  }
  return toSend;
}


export function preparePremiumEnquiriesSearchParams(advSParams){
  let toSend = {}
    toSend['premium_enquiry_no'] = advSParams.premium_enquiry_no
    toSend['created_at_from'] = advSParams.created_at_from
    toSend['created_at_upto'] = advSParams.created_at_upto
    toSend['delete_filter']= advSParams.delete_filter
    toSend['deleted_at_from'] = advSParams.deleted_at_from
    toSend['deleted_at_upto'] = advSParams.deleted_at_upto
    if (advSParams.broker_ids) {
      toSend['broker_ids'] = advSParams.broker_ids.map(i => i.value).filter(i => i!== null)
    }
    if (advSParams.building_ids) {
      toSend['building_ids'] = advSParams.building_ids.map(i => i.value).filter(i => i!== null)
    }
    if (advSParams.status_ids) {
      toSend['status_ids'] = advSParams.status_ids.map(i => i.value).filter(i => i!== null)
    }
    if (advSParams.broker_uuids) {
      toSend['broker_uuids'] = advSParams.broker_uuids.map(i => i.value).filter(i => i!== null)
    }
    if (advSParams.meeting_executive_ids) {
      toSend['meeting_executive_ids'] = advSParams.meeting_executive_ids.map(i => i.value).filter(i => i!== null)
    }

    
  return toSend;
}




export function decodeMeetingSearchParams(advSParams){
  let sendData = {};
  if(advSParams.start_date_time_from && isValidDate(advSParams.start_date_time_from)){
    sendData.start_date_time_from = advSParams.start_date_time_from;
  }
  if(advSParams.end_date_time_upto && isValidDate(advSParams.end_date_time_upto)){
    sendData.end_date_time_upto = advSParams.end_date_time_upto;
  }
  if(advSParams.broker_ids && advSParams.broker_ids.length > 0){
    sendData.broker_ids = advSParams.broker_ids.map(broker => broker.value).filter(broker=> broker !== null);
  }
  if(advSParams.categorization && advSParams.categorization.length > 0){
    sendData.categorization = advSParams.categorization.map(broker => broker.value).filter(broker=> broker !== null);
  }
  if(advSParams.signing_off_done && advSParams.signing_off_done !== null ){
    sendData.signing_off_done = advSParams.signing_off_done.value;
  }
  if(advSParams.team_lead && advSParams.team_lead.id !== null ){
    sendData.tl_id = advSParams.team_lead.id;
  }
  if(advSParams.team_lead && advSParams.team_lead.value !== null ){
    sendData.tl_id = advSParams.team_lead.value;
  }
  if(advSParams.meeting_recorded && advSParams.meeting_recorded.value !== null ){
    sendData.meeting_recorded = advSParams.meeting_recorded.value;
  }

  if(advSParams.meeting_types && advSParams.meeting_types.length > 0){
    sendData["meeting_types"] = advSParams.meeting_types.map(exec => exec.value).filter(exec=> exec !== null);;
  }
  if(advSParams.field_executives && Object.keys(advSParams.field_executives).includes("id")) {
    sendData["user_ids"] = advSParams.field_executives.id;
  }
  if(advSParams.field_executives && advSParams.field_executives.length > 0){
    sendData["user_ids"] = advSParams.field_executives.map(exec => exec.value).filter(exec=> exec !== null);
  }
  if(advSParams.user_ids && advSParams.user_ids.length > 0){
    sendData.user_ids = advSParams.user_ids.map(exec => exec.id).filter(exec=> exec !== null);;
  }
  if(advSParams.tl_id && advSParams.tl_id!==null){
    sendData.tl_id = advSParams.tl_id.id;
  }
  if(advSParams.manager_id && advSParams.manager_id!==null){
    sendData.manager_id = advSParams.manager_id.id;
  }
  if(advSParams.enquiry_no && advSParams.enquiry_no!==null){
    sendData.enquiry_no = advSParams.enquiry_no;
  }
  if(advSParams.start_date && isValidDate(advSParams.start_date)){
    sendData.start_date = advSParams.start_date;
  }
  if(advSParams.end_date && isValidDate(advSParams.end_date)){
    sendData.end_date = advSParams.end_date;
  }
  if(advSParams.resource_type ){
    sendData.resource_type = advSParams.resource_type;
  }
  return sendData;
}
export function decodeMyCpMeetingSearchParams(advSParams){
  let sendData = {};

  if(advSParams.created_at_from && isValidDate(advSParams.created_at_from)){
    sendData.created_at_from = advSParams.created_at_from;
  }
  if(advSParams.created_at_upto && isValidDate(advSParams.created_at_upto)){
    sendData.created_at_upto = advSParams.created_at_upto;
  }
  if(advSParams.meeting_scheduled_from && isValidDate(advSParams.meeting_scheduled_from)){
    sendData.meeting_scheduled_from = advSParams.meeting_scheduled_from;
  }
  if(advSParams.meeting_scheduled_upto && isValidDate(advSParams.meeting_scheduled_upto)){
    sendData.meeting_scheduled_upto = advSParams.meeting_scheduled_upto;
  }
  if(advSParams.name && advSParams.name!==null){
    sendData.name = advSParams.name;
  }
  if(advSParams.firm_name && advSParams.firm_name!==null){
    sendData.firm_name = advSParams.firm_name;
  }
  if(advSParams.ticket_status ){
    sendData.ticket_status = advSParams.ticket_status;
  }
  if(advSParams.meeting_executive_ids && advSParams.meeting_executive_ids.length > 0){
    sendData.meeting_executive_ids = advSParams.meeting_executive_ids.map(exec => exec.id).filter(exec=> exec !== null);;
  }
  if(advSParams.building_ids && advSParams.building_ids.length > 0){
    sendData.building_ids = advSParams.building_ids.map(exec => exec.id).filter(exec=> exec !== null);;
  }
  if(advSParams.request_uuids && advSParams.request_uuids.length > 0){
    sendData.request_uuids = advSParams.request_uuids.map(exec => exec.id).filter(exec=> exec !== null);;
  }
  if(advSParams.broker_uuids && advSParams.broker_uuids.length > 0){
    sendData.broker_uuids = advSParams.broker_uuids.map(exec => exec.id).filter(exec=> exec !== null);;
  }

  return sendData;
}

export function decodeCampaignSearchParams(advSParams){
  let sendData = {};
  if(advSParams.created_at_from && isValidDate(advSParams.created_at_from)){
    sendData.created_at_from = advSParams.created_at_from;
  }
  if(advSParams.created_at_upto && isValidDate(advSParams.created_at_upto)){
    sendData.created_at_upto = advSParams.created_at_upto;
  }
  if(advSParams.user_ids && advSParams.user_ids.length > 0){
    sendData.user_ids = advSParams.user_ids.map(user => user.value).filter(user=> user !== null);
  }
  if(advSParams.campaign_statuses && advSParams.campaign_statuses !== null ){
    sendData.campaign_statuses = advSParams.campaign_statuses;
  }
  if(advSParams.project_ids && advSParams.project_ids.length > 0){
    sendData.project_ids = advSParams.project_ids.map(proj => proj.value).filter(proj=> proj !== null);
  }
  if(advSParams.campaign_types && advSParams.campaign_types.length > 0){
    sendData.campaign_types = advSParams.campaign_types.map(camp => camp.value).filter(camp=> camp !== null);
  }
  if(advSParams.broker_ids && advSParams.broker_ids.length > 0){
    sendData.broker_ids = advSParams.broker_ids.map(brok => brok.value).filter(brok=> brok !== null);
  }
  return sendData;
}


export function decodeCPBrokerSearchParams(advSParams){
  let sendData = {};
  if(advSParams.next_call_date_from && isValidDate(advSParams.next_call_date_from)){
    sendData.next_call_date_from = advSParams.next_call_date_from;
  }
  if(advSParams.next_call_date_upto && isValidDate(advSParams.next_call_date_upto)){
    sendData.next_call_date_upto = advSParams.next_call_date_upto;
  }
  if(advSParams.empanelment_date_from && isValidDate(advSParams.empanelment_date_from)){
    sendData.empanelment_date_from = advSParams.empanelment_date_from;
  }
  if(advSParams.empanelment_date_upto && isValidDate(advSParams.empanelment_date_upto)){
    sendData.empanelment_date_upto = advSParams.empanelment_date_upto;
  }
  if(advSParams.meeting_scheduled_from && isValidDate(advSParams.meeting_scheduled_from)){
    sendData.meeting_scheduled_from = advSParams.meeting_scheduled_from;
  }
  if(advSParams.meeting_scheduled_upto && isValidDate(advSParams.meeting_scheduled_upto)){
    sendData.meeting_scheduled_upto = advSParams.meeting_scheduled_upto;
  }
  if(advSParams.last_meeting_date_from && isValidDate(advSParams.last_meeting_date_from)){
    sendData.last_meeting_date_from = advSParams.last_meeting_date_from;
  }
  if(advSParams.last_meeting_date_upto && isValidDate(advSParams.last_meeting_date_upto)){
    sendData.last_meeting_date_upto = advSParams.last_meeting_date_upto;
  }
  if(advSParams.name){
    sendData.name = advSParams.name;
  }
  if(advSParams.firm_name){
    sendData.firm_name = advSParams.firm_name;
  }
  if(advSParams.email){
    sendData.email = advSParams.email;
  }
  if(advSParams.contact_number){
    sendData.contact_number = advSParams.contact_number;
  }
  if(advSParams.affiliate_filter && advSParams.affiliate_filter.value){
    sendData.affiliate_filter = advSParams.affiliate_filter.value === 'yes';
  }
  if(advSParams.is_mou_uploaded && advSParams.is_mou_uploaded.value){
    sendData.is_mou_uploaded = advSParams.is_mou_uploaded.value;
  }
  if(advSParams.loan_mou_uploaded && advSParams.loan_mou_uploaded.value){
    sendData.loan_mou_uploaded = advSParams.loan_mou_uploaded.value;
  }
  if(advSParams.crm_statuses && advSParams.crm_statuses.length > 0){
    sendData.crm_statuses = advSParams.crm_statuses.map(status => status.value).filter(status=> status !== null);
  }
  if(advSParams.localities && advSParams.localities.length > 0){
    sendData.localities = advSParams.localities.map(locality => locality.value).filter(locality=> locality !== null);
  }
  if(advSParams.performance && advSParams.performance.length > 0){
    sendData.performance = advSParams.performance.map(perf => perf.value).filter(perf=> perf !== null);
  }
  if(advSParams.categorization && advSParams.categorization.length > 0){
    sendData.categorization = advSParams.categorization.map(category => category.value).filter(category=> category !== null);
  }
  if(advSParams.categorization && advSParams.categorization.length > 0){
    sendData.categorization = advSParams.categorization.map(category => category.value).filter(category=> category !== null);
  }
  if(advSParams.meeting_executive_ids && advSParams.meeting_executive_ids.length > 0){
    sendData.meeting_executive_ids = advSParams.meeting_executive_ids.map(executive => executive.value).filter(executive=> executive !== null);
  }
  if(advSParams.calling_executive_ids && advSParams.calling_executive_ids.length > 0){
    sendData.calling_executive_ids = advSParams.calling_executive_ids.map(executive => executive.value).filter(executive=> executive !== null);
  }
  if(advSParams.cities && advSParams.cities.length > 0){
    sendData.cities = advSParams.cities.map(city => city.value).filter(city=> city !== null);
  }
  if(advSParams.kyc_statuses && advSParams.kyc_statuses.length > 0){
    sendData.kyc_statuses = advSParams.kyc_statuses.map(kyc => kyc.value).filter(kyc=> kyc !== null);
  }
  if(advSParams.sub_status_ids && advSParams.sub_status_ids.length > 0){
    sendData.sub_status_ids = advSParams.sub_status_ids.map(status => status.id).filter(status=> status !== null);
  }
  if(advSParams.tl_id && advSParams.tl_id.value){
    sendData.tl_id = advSParams.tl_id.value;
  }
  return sendData;
}

export function isValidDate(date) {
  return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
}
export function decodeSortKey(key){
  if(key === "ncd"){
    return "next_call_date";
  }
  return key;
}

export const MEETING_SCHEDULED = 32
export const DEAD_STATUS_ID = 62
export const EMPANELMENT_STATUS_IDS = [36, 38, 39,77,70]
export const CATEGORIZATION_CAN_CHANGE_IDS = ["P0","P1"]